import { render, staticRenderFns } from "./TheRelaySIPEndpoint.vue?vue&type=template&id=8004c358&scoped=true&"
import script from "./TheRelaySIPEndpoint.vue?vue&type=script&lang=js&"
export * from "./TheRelaySIPEndpoint.vue?vue&type=script&lang=js&"
import style0 from "./TheRelaySIPEndpoint.vue?vue&type=style&index=0&id=8004c358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8004c358",
  null
  
)

export default component.exports